// extracted by mini-css-extract-plugin
export default {"headerContainer":"PropertiesBreadcrumbsPageHeader-module__headerContainer__UfJagim"};